module.exports = __webpack_public_path__ + "static/media/graham-thumbs-up.28ce0b97.png";